<template>
  <div class="contacts-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/index' }">数据概览</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/index' }">应用中心</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/index' }">会议壳</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/meeting-list' }">会议列表</el-breadcrumb-item>
      <el-breadcrumb-item>{{this.$route.query.itemName}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/apps/shell/content/index/' + this.$route.params.mId }">会议内容管理</el-breadcrumb-item>
      <el-breadcrumb-item>联系人管理</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page-content">
      <div class="content-header">
        <el-button type="primary" size="mini" @click="addContacts">添加联系人</el-button>
      </div>
      <div class="contacts-list" v-if="dataList.length > 0">
        <div class="contacts-item" v-for="item in dataList" :key="item.id">
          <div class="left" v-if="item.avatar">
            <img :src="item.avatar"/>
          </div>
          <div class="right">
            <div class="name">姓名：{{item.name}}</div>
            <div class="info-item" v-if="item.phone">电话：{{item.phone}}</div>
            <div class="info-item" v-if="item.mail">邮箱：{{item.mail}}</div>
            <div class="info-item" v-if="item.duty">职责：{{item.duty}}</div>
            <div class="ewm" v-if="item.ewm">
              <el-popover placement="top" width="100" trigger="hover">
                <img slot="reference" src="../../../../../assets/img/shell/content/ewm-line.png"/>
                <img style="width: 100%;height: 100px;" :src="item.ewm"/>
              </el-popover>
            </div>
            <div class="info-item" v-if="item.mark">备注：
              <el-popover placement="top" width="100" trigger="hover">
                <el-tag type="info" slot="reference" size="mini">详情</el-tag>
                <div class="mark">{{item.mark}}</div>
              </el-popover>
            </div>
            <div class="item-options">
              <div class="edit" @click="editItem(item.id)">编辑</div>
              <div class="del" @click="delItem(item.id)">删除</div>
            </div>
          </div>
        </div>
      </div>
      <div class="no-list" v-else>
        <el-empty :image-size="200"></el-empty>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data () {
    return {
      dataList: []
    }
  },
  created () {
    this.getDataList()
  },
  methods: {
    // 获取会议列表
    async getDataList () {
      const { data: res } = await this.$http.get('/shell-contacts-list', { params: { mId: this.$route.params.mId } })
      if (res.status === 200) {
        this.dataList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    // 添加
    addContacts () {
      this.$router.push({ path: '/admin/apps/shell/content/contacts/' + this.$route.params.mId + '/add', query: { meetingName: this.$route.query.itemName } })
    },
    // 编辑
    editItem (id) {
      this.$router.push({ path: '/admin/apps/shell/content/contacts/' + this.$route.params.mId + '/edit/' + id, query: { meetingName: this.$route.query.itemName } })
    },
    // 删除
    async delItem (id) {
      const { data: res } = await this.$http.delete('/shell-contacts/' + id)
      if (res.status === 200) {
        this.$message.success(res.msg)
        await this.getDataList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
.content-header{
  text-align: right;
}
.contacts-list{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  padding: 20px;
}
.contacts-list .contacts-item{
  width: 400px;
  height: 140px;
  background-color: rgba(255,255,255,1);
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0 20px 20px 0;
}
.contacts-list .contacts-item:hover{
  box-shadow: rgb(0 0 0 / 15%) 0px 15px 25px, rgb(0 0 0 / 5%) 0px 5px 10px;
}
.contacts-list .contacts-item .left{
  width: 140px;
  height: 100%;
}
.contacts-list .contacts-item .left img{
  width: 100%;
  height: 100%;
}
.contacts-list .contacts-item .right{
  flex: 1;
  text-align: left;
  position: relative;
  height: 100%;
}
.contacts-list .contacts-item .right .name{
  padding: 10px 10px 4px 10px;
  font-size: 13px;
  font-weight: bold;
  color: #303133;
}
.contacts-list .contacts-item .right .info-item{
  margin-left: 10px;
  font-size: 13px;
  color: #909399;
  margin-top: 2px;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.contacts-list .contacts-item .right .ewm{
  position: absolute;
  top: 4px;
  right: 4px;
  height: 30px;
  width: 30px;
}
.contacts-list .contacts-item .right .ewm img{
  width: 100%;
  height: 100%;
}
.contacts-list .contacts-item .right .item-options{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
}
.contacts-list .contacts-item .right .item-options .edit{
  background-color: #409EFF;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  flex: 1;
  text-align: center;
}
.contacts-list .contacts-item .right .item-options .del{
  background-color: #F56C6C;
  color: #FFFFFF;
  font-size: 13px;
  line-height: 26px;
  cursor: pointer;
  flex: 1;
  text-align: center;
}
</style>
